export default __webpack_public_path__ + "static/Holdenmanzlarge-f75bda101edce8d6c5fdb4006a3eb8af.jpg";